import React from 'react'
import '../../App.css'
import Reglog from '../../assets/reglogo.jpg'

const Sign = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col">
          <div className="card card-registration">
            <div className="row g-0">
              <div className="col-xl-6 d-none d-xl-block">
                <img
                  src="https://img.fixthephoto.com/blog/images/gallery/news_preview_mob_image__preview_14461.jpg"
                  alt={Reglog}
                  className="img-fluid"
                  style={{ height: '-webkit-fill-available' }}
                />
              </div>
              <div className="col-xl-6">
                <div className="card-body p-md-1 text-black">
                  <h4 className="mb-4 text-uppercase">KRT Business</h4>

                  <div className="row">
                    <div className="col-md-6 mb-0">
                      <div className="form-outline">
                        <input
                          type="text"
                          id="form3Example1m"
                          className="form-control form-control-sm"
                        />
                        <label
                          className="form-label"
                          style={{ marginleft: '0px' }}
                        >
                          First name
                        </label>
                        <div className="form-notch">
                          <div
                            className="form-notch-leading"
                            style={{ width: '9px' }}
                          ></div>
                          <div
                            className="form-notch-middle"
                            style={{ width: '68.8px' }}
                          ></div>
                          <div className="form-notch-trailing"></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-outline">
                        <input
                          type="text"
                          id="form3Example1n"
                          className="form-control form-control-sm"
                        />
                        <label
                          className="form-label"
                          htmlFor="form3Example1n"
                          style={{ marginleft: '0px' }}
                        >
                          Last name
                        </label>
                        <div className="form-notch">
                          <div
                            className="form-notch-leading"
                            style={{ width: '9px' }}
                          ></div>
                          <div
                            className="form-notch-middle"
                            style={{ width: '68px' }}
                          ></div>
                          <div className="form-notch-trailing"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-outline mb-3">
                    <input
                      type="text"
                      id="form3Example8"
                      className="form-control form-control-sm"
                    />
                    <label
                      className="form-label"
                      htmlFor="form3Example8"
                      style={{ marginleft: '0px' }}
                    >
                      Address
                    </label>
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: '9px' }}
                      ></div>
                      <div
                        className="form-notch-middle"
                        style={{ width: '55.2px' }}
                      ></div>
                      <div className="form-notch-trailing"></div>
                    </div>
                  </div>

                  <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                    <h6 className="mb-0 me-4">Gender: </h6>

                    <div className="form-check form-check-inline mb-0 me-4">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="femaleGender"
                        value="option1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="femaleGender"
                      >
                        Female
                      </label>
                    </div>

                    <div className="form-check form-check-inline mb-0 me-4">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="maleGender"
                        value="option2"
                      />
                      <label className="form-check-label" htmlFor="maleGender">
                        Male
                      </label>
                    </div>

                    <div className="form-check form-check-inline mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="otherGender"
                        value="option3"
                      />
                      <label className="form-check-label" htmlFor="otherGender">
                        Other
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div id="select-wrapper-74555" className="select-wrapper">
                        <div className="form-outline">
                          <input
                            className="form-control form-control-sm select-input placeholder-active active"
                            type="text"
                            role="listbox"
                            aria-multiselectable="false"
                            aria-disabled="false"
                            aria-haspopup="true"
                            aria-expanded="false"
                            readonly="true"
                          />
                          <span className="select-arrow"></span>
                          <div className="form-notch">
                            <div
                              className="form-notch-leading"
                              style={{ width: '9px' }}
                            ></div>
                            <div
                              className="form-notch-middle"
                              style={{ width: '0px' }}
                            ></div>
                            <div className="form-notch-trailing"></div>
                          </div>
                          <div className="form-label select-fake-value">
                            State
                          </div>
                        </div>
                        <select className="select select-initialized">
                          <option value="1">State</option>
                          <option value="2">Option 1</option>
                          <option value="3">Option 2</option>
                          <option value="4">Option 3</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div
                        id="select-wrapper-177472"
                        className="select-wrapper"
                      >
                        <div className="form-outline">
                          <input
                            className="form-control form-control-sm select-input placeholder-active active"
                            type="text"
                            role="listbox"
                            aria-multiselectable="false"
                            aria-disabled="false"
                            aria-haspopup="true"
                            aria-expanded="false"
                            readonly="true"
                          />
                          <span className="select-arrow"></span>
                          <div className="form-notch">
                            <div
                              className="form-notch-leading"
                              style={{ width: '9px' }}
                            ></div>
                            <div
                              className="form-notch-middle"
                              style={{ width: '0px' }}
                            ></div>
                            <div className="form-notch-trailing"></div>
                          </div>
                          <div className="form-label select-fake-value">
                            City
                          </div>
                        </div>
                        <select className="select select-initialized">
                          <option value="1">City</option>
                          <option value="2">Option 1</option>
                          <option value="3">Option 2</option>
                          <option value="4">Option 3</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-outline mb-2">
                    <input
                      type="text"
                      id="form3Example90"
                      className="form-control form-control-sm"
                    />
                    <label className="form-label">Pincode</label>
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: '9px' }}
                      ></div>
                      <div
                        className="form-notch-middle"
                        style={{ width: '54.4px' }}
                      ></div>
                      <div className="form-notch-trailing"></div>
                    </div>
                  </div>

                  <div className="form-outline mb-2">
                    <input
                      type="text"
                      id="form3Example99"
                      className="form-control form-control-sm"
                    />
                    <label
                      className="form-label"
                      htmlFor="form3Example99"
                      style={{ marginleft: '0px' }}
                    >
                      Course
                    </label>
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: '9px' }}
                      ></div>
                      <div
                        className="form-notch-middle"
                        style={{ width: '49.6px' }}
                      ></div>
                      <div className="form-notch-trailing"></div>
                    </div>
                  </div>

                  <div className="form-outline mb-2">
                    <input
                      type="text"
                      id="form3Example97"
                      className="form-control form-control-sm"
                    />
                    <label
                      className="form-label"
                      htmlFor="form3Example97"
                      style={{ marginleft: '0px' }}
                    >
                      Email ID
                    </label>
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: '9px' }}
                      ></div>
                      <div
                        className="form-notch-middle"
                        style={{ width: '56px' }}
                      ></div>
                      <div className="form-notch-trailing"></div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end pt-2">
                    <button type="button" className="btn btn-light btn-lg">
                      Reset all
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning btn-lg ms-2"
                    >
                      Submit form
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sign
